// extracted by mini-css-extract-plugin
export default {"disclaimer":"static-React-Applications-UniversalLogin-UniversalLogin-___UniversalLogin-module__disclaimer"};